import styled from "styled-components";

import Background1 from '../../../../../assets/images/background/onibus.jpg';

export const BaseComp = styled.div`
    display: flex;
    justify-content: left;
    flex-direction: column;
    align-items: left;
    padding: 1%;
    background-color: var(--setra-blue);
    
    color: var(--setra-blue);
    font-weight: bold;
     @media only screen and (max-width: 1200px) {
        justify-content: center;
        align-items: center;
    }

`;
export const BannerContent = styled.div`
    display: flex;
    flex-direction: row;
    background-color: var(--setra-blue);
    border-radius: 16px;
    padding: 1%;
    max-width: 1300px;
    width: auto;
    @media only screen and (max-width: 1200px) {
        flex-direction: column;
        align-items: center;
    }
`;


export const BannerImg = styled.img`
    display: flex;
    align-items: center;
    width: 40%;
    height: auto;
    padding: 1%;
    @media only screen and (max-width: 1200px) {
        width: 80%;
    }
`;

export const BannerText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    border-radius: 16px;
    padding: 1%;

    p {
        color: white;
        font-size: 20px;
        margin: 1%;
        font-weight: normal;
        font-family: "Montserrat", Sans-serif;
    }

    @media only screen and (max-width: 800px) {
        max-width: 90%;
        align-items: left;
        margin: 3% 5%;
    }
`;